(function () {
  function init(root) {
    var track = root.querySelector('.category-slider-track');
    var prevBtn = root.querySelector('.category-slider-arrow--prev');
    var nextBtn = root.querySelector('.category-slider-arrow--next');
    if (!track || !prevBtn || !nextBtn || root.dataset.sliderInit === 'true') return;
    root.dataset.sliderInit = 'true';

    function scrollAmount() {
      var item = track.querySelector('.category-slider-item');
      var gap = 28;
      return item ? (item.offsetWidth + gap) * 3 : 300;
    }

    function updateArrows() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
      prevBtn.classList.toggle('is-disabled', prevBtn.disabled);
      nextBtn.classList.toggle('is-disabled', nextBtn.disabled);
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      window.setTimeout(updateArrows, 400);
    });
    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      window.setTimeout(updateArrows, 400);
    });
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  function initAll() {
    document.querySelectorAll('.category-slider-section').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.category-slider-section');
    if (root) init(root);
  });
})();
